import { get, post } from './client'

/** 敏感操作的二次验证凭据；重试请求时放到 `X-Security-Proof` 头 */
export interface SecurityProof {
  proof_token: string
  expires_at: number
  method: string
  scope: string
}

export interface VerificationMethodOption {
  method: string
  available: boolean
  reason?: string
}

export interface VerificationRequirements {
  scope: string
  methods: VerificationMethodOption[]
  oauth_providers?: Array<{ slug: string; name: string }>
  password_encryption_enabled?: boolean
}

/**
 * 查询某个敏感操作可用的验证方式
 * GET /api/verify/methods?scope=...
 */
export async function getVerificationMethodsApi(scope: string): Promise<VerificationRequirements> {
  return get('/api/verify/methods', { scope })
}

/**
 * 申请敏感操作凭据
 * POST /api/verify
 */
export async function requestSecurityProofApi(params: {
  method: string
  scope: string
  context?: Record<string, unknown>
  code?: string
  password?: string
}): Promise<SecurityProof> {
  return post('/api/verify', params)
}

/**
 * Passkey 验证发起（敏感操作）
 * POST /api/user/passkey/verify/begin
 */
export async function passkeyVerifyBeginApi(params: {
  scope: string
  context?: Record<string, unknown>
  rp_id?: string
}): Promise<{ options: unknown }> {
  return post('/api/user/passkey/verify/begin', params)
}

/**
 * Passkey 验证完成（敏感操作），返回凭据
 * POST /api/user/passkey/verify/finish
 */
export async function passkeyVerifyFinishApi(params: {
  scope: string
  context?: Record<string, unknown>
  credential: unknown
}): Promise<SecurityProof> {
  return post('/api/user/passkey/verify/finish', params)
}

/**
 * 2FA 状态
 * GET /api/user/2fa/status
 */
export async function get2FAStatusSimpleApi(): Promise<{ enabled: boolean }> {
  return get('/api/user/2fa/status')
}

/**
 * Passkey 状态
 * GET /api/user/passkey
 */
export async function getPasskeyStatusSimpleApi(): Promise<{ enabled: boolean }> {
  return get('/api/user/passkey')
}
